var map = {
	"./big-img.png": 48691,
	"./destination1.png": 52506,
	"./destination2.png": 28753,
	"./destination3.png": 80360,
	"./destination4.png": 59975,
	"./destination5.png": 84190,
	"./destination6.png": 20917,
	"./destination7.png": 9292,
	"./destination8.png": 13307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44936;